import { Modal, Table, Typography, Tag, Space, Button } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import type { RecvizRow, ExportStatus } from '@/api/recviz'

const { Text } = Typography

interface RecvizPreviewModalProps {
  visible: boolean
  onClose: () => void
  period: string
  rowsCount: number
  preview: RecvizRow[]
  exportStatus: ExportStatus | null
  loading?: boolean
}

export function RecvizPreviewModal({
  visible,
  onClose,
  period,
  rowsCount,
  preview,
  exportStatus,
  loading = false,
}: RecvizPreviewModalProps) {
  const navigate = useNavigate()

  const handleViewFull = () => {
    onClose()
    navigate('/org/recviz-result')
  }
  const columns = [
    {
      title: 'ID отделения',
      dataIndex: 'id_otd',
      key: 'id_otd',
      width: 120,
    },
    {
      title: 'Наименование',
      dataIndex: 'code_otd_name_full',
      key: 'code_otd_name_full',
      width: 250,
      ellipsis: true,
    },
    {
      title: 'Филиал',
      dataIndex: 'fil_name',
      key: 'fil_name',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'Служба',
      dataIndex: 'serv_name',
      key: 'serv_name',
      width: 180,
      ellipsis: true,
    },
    {
      title: 'Коек (факт)',
      dataIndex: 'kf_total_fact',
      key: 'kf_total_fact',
      width: 120,
      align: 'right' as const,
    },
    {
      title: 'План случаи',
      dataIndex: 'cases_plan_gen',
      key: 'cases_plan_gen',
      width: 120,
      align: 'right' as const,
    },
  ]

  return (
    <Modal
      title={`Справочник реквизитов — Период ${period}`}
      open={visible}
      onCancel={onClose}
      width={1200}
      footer={
        <Space>
          <Button onClick={onClose}>Закрыть</Button>
          <Button type="primary" icon={<EyeOutlined />} onClick={handleViewFull}>
            Подробнее
          </Button>
        </Space>
      }
      loading={loading}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {/* Сводка */}
        <div style={{ display: 'flex', gap: 16, padding: '12px 0' }}>
          <div>
            <Text type="secondary">Всего записей:</Text>{' '}
            <Text strong>{rowsCount}</Text>
          </div>
          <div>
            <Text type="secondary">Период:</Text>{' '}
            <Text strong>{period}</Text>
          </div>
          {exportStatus && (
            <div>
              <Text type="secondary">Экспорт в ClickHouse:</Text>{' '}
              {exportStatus.success ? (
                <Tag color="green">
                  ✓ {exportStatus.rows_exported} записей в {exportStatus.table}
                </Tag>
              ) : (
                <Tag color="red">✗ Ошибка: {exportStatus.error}</Tag>
              )}
            </div>
          )}
        </div>

        {/* Превью первых 10 записей */}
        <div>
          <Text type="secondary">Превью (первые 10 записей):</Text>
          <Table
            columns={columns}
            dataSource={preview}
            rowKey="id_otd"
            pagination={false}
            size="small"
            scroll={{ x: 'max-content' }}
            style={{ marginTop: 8 }}
          />
        </div>

        {rowsCount > 10 && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            Показаны первые 10 из {rowsCount} записей
          </Text>
        )}
      </Space>
    </Modal>
  )
}
